import absoluteUrl from "next-absolute-url";
import {getAxiosInstance} from "src/server/utils/getAxiosInstance";
import * as ProductsApi from "src/core/api/products";
import {generateSiteMap} from "src/server/sitemaps";
import {getSiteInCluster} from "src/server/clusters";
import {ALL_PRODUCTS_DELIVERY_TYPE} from "src/server/constants";

const CategoriesSitemap = () => {};

export const getServerSideProps = async ({res, req, query}) => {
  const {host} = absoluteUrl(req);
  const shop = query.shop;
  const axiosInstance = getAxiosInstance(shop, host);
  try {
    const data = await getAllCategoryPaths(axiosInstance);
    const siteConfig = getSiteInCluster(host);
    const sitemap = await generateSiteMap({
      shop,
      host: siteConfig.canonicalDomain,
      data,
      siteMapName: "categories",
    });
    res.setHeader("Content-Type", "text/xml");
    res.write(sitemap);
    res.end();
  } catch (e) {
    console.error(e);
  }
  return {
    props: {},
  };
};

async function getAllCategoryPaths(axiosInstance) {
  const {data: categories} = await ProductsApi.categories(
    {delivery_type: ALL_PRODUCTS_DELIVERY_TYPE, include_subcategories: true},
    axiosInstance
  );

  const categoryById = categories.reduce((acc, c) => {
    acc[c.attributes.id] = c;
    return acc;
  }, {});

  return categories.map(category => {
    const parentCategoryId = category.attributes.parent_category_id;

    if (parentCategoryId !== null) {
      return {
        path: `/categories/${categoryById[parentCategoryId].attributes.slug}/${category.attributes.slug}/`,
      };
    }
    return {
      path: `/categories/${category.attributes.slug}/`,
    };
  });
}

export default CategoriesSitemap;
